export const SET_STATISTIC_ORDER_FILTER = 'SET_STATISTIC_ORDER_FILTER';
export const RESET_STATISTIC_ORDER_FILTER = 'RESET_STATISTIC_ORDER_FILTER';

export const SET_TABLE_LIST = 'SET_TABLE_LIST';
export const SET_TABLE_PAGE_INFO = 'SET_TABLE_PAGE_INFO';
export const RESET_TABLE_PAGE_INFO = 'RESET_TABLE_PAGE_INFO';
